import axios from "axios";

const instance = axios.create({   
    baseURL: "https://adm-afin.vexia.com.br/",   
    headers: {
        'Content-Type': 'application/json'
    },
});

export default instance;
